module.exports = __webpack_public_path__ + "img/lk_type_sq.aa15f960.svg";